var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$fetchState.pending)?_c('div',[(_vm.pageType === 'post')?_c('PostPage'):_vm._e(),_vm._v(" "),(_vm.pageType === 'category')?_c('CategoryPage'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }